var nativePromise = window.Promise,
    proxiedPromise = new Proxy(nativePromise, {
        get(target, key) {
            if (key === 'create') {
                return executor => new nativePromise(executor);
            }
            else if (key === 'inert') {
                return () => new nativePromise(() => {});
            }

            return Reflect.get(...arguments);
        }
    });

export default proxiedPromise;